import { registerAction } from '../../Action'
import { workflowActions } from '../workflowActions'
import {
  workflowErrors,
  stageErrors,
  newStageErrors,
  assignmentErrors,
  responseErrors,
  defaultError,
} from './errors'

const updateNestedState = (state) => ({
  ...state,
  entityDataByView: {
    ...(state.entityDataByView && state.entityDataByView),
  },
})

const getMessageByStatusCode = ({
  context,
  statusCode,
  entity,
  requestType,
}) => {
  switch (context) {
    case 'workflow':
      return workflowErrors[requestType][statusCode](entity) || defaultError
    case 'stage':
      return stageErrors[requestType][statusCode](entity) || defaultError
    case 'newStage':
      return newStageErrors[requestType][statusCode](entity) || defaultError
    case 'assignment':
      return assignmentErrors[requestType][statusCode](entity) || defaultError
    case 'response':
      return responseErrors[requestType][statusCode](entity) || defaultError
    default:
      return defaultError
  }
}

const workflowErrorReducer = (state = {}, action) => {
  const { context, entity, error, requestType, stageId } = action.payload
  const statusCode = error.message.match(/\d/g).join('')
  const errorObject = {
    [context]: {
      status: statusCode,
      message: getMessageByStatusCode({
        context,
        statusCode,
        entity,
        requestType,
      }),
      stageId,
    },
  }

  return updateNestedState(state, {
    error: errorObject,
    loading: {
      ...action.payload.loading,
    },
  })
}

const workflowError = registerAction(workflowActions.WORKFLOW_ERROR, {
  reducer: workflowErrorReducer,
})

export default workflowError
